import {ListResponseDto} from "@/@types/base.types.ts";

export enum OwnerStatus {
    Active, Inactive, Suspended
};

export type OwnerListItemResponseDto = {
    avatarUrl: string;
    id: string;
    name?: string;
    email?: string;
    phoneNumber?: string;
    language?: string;
    status: OwnerStatus;
    apartments: number;
    agreements: number;
    trustees: number;
    invitedAt?: Date;
};

export type OwnerListResponseDto = (
    ListResponseDto<OwnerListItemResponseDto>
    );

export type OwnerDetailsResponseDto = {
    avatarUrl: string;
    id: string;
    name?: string;
    email?: string;
    phoneNumber?: string;
    language?: string;
    status: OwnerStatus;
    apartments: number;
    agreements: number;
    trustees: number;
    tin?: string;
    invitedAt?: Date;
};

export type GetOwnerLookupListItemResponseDto = {
    id: string;
    name?: string;
};

export type GetOwnerLookupListResponseDto = (
    ListResponseDto<GetOwnerLookupListItemResponseDto>
    );


export type OwnerPermissionsResponseDto = {
    showCalendar: boolean;
    showFinances: boolean;
    createBookings: boolean;
    placeOrders: boolean;
    bookingDurationLimit: number;
    yearlyBookingLimit: number;
    loginToAccount: boolean;
};
